<div class="login-page">
    <div class="teaser" disable-empty>
        <h2 i18n="@@landingpage.login.teaser.headline" disable-empty format-text>null</h2>
        <h3 i18n="@@landingpage.login.teaser.subheadline" disable-empty format-text>null</h3>
        <p i18n="@@landingpage.login.teaser.text" disable-empty format-text>null</p>
    </div>
    <form [formGroup]="loginForm" (submit)="login()" action="/" autocomplete="off">
        <h2 i18n="@@landingpage.login.headline" class="" disable-empty format-text>null</h2>
        <div class="signup-options">
            <a 
                class="signup-link"
                [routerLink]="['/Registration']"
                *ngIf="showSignup"
                i18n="@@landingpage.login.signup.button"
                test-id="login.link.signup"
            >Sign up</a>
        </div>
        <validation [message]="authError"></validation>
        <div class="form-row" *ngIf="!disableEmail">
            <label for="username" i18n="@@landingpage.label.username">E-mail address</label>
            <input autocomplete="off"
                test-id="login.input.username"
                name="username"
                id="username"
                value=""
                type="text"
                formControlName="UserName"
                (keyup)="usernameInput($event)"
                (change)="usernameInput($event)"
                #username
                [class.error]="loginForm.controls.UserName.invalid && loginForm.controls.UserName.touched"
            >
            <validation [control]="loginForm.controls.UserName">
                <validation-message type="required" i18n="@@landingpage.login.validation.message.username.required">You must enter your user name to log in.</validation-message>
            </validation>
        </div>
        <div class="form-row" *ngIf="showInternalLogin && !disableInternalLogin && !disablePassword">
            <label for="password" i18n="@@landingpage.label.password">Password</label>
            <input #password autocomplete="off"
                test-id="login.input.password"
                name="password"
                id="password"
                value=""
                type="password"
                formControlName="Password"
                (keyup)="passwordInput($event)"
                [class.error]="loginForm.controls.Password.invalid && loginForm.controls.Password.touched">
            <validation [control]="loginForm.controls.Password">
                <validation-message type="required" i18n="@@landingpage.login.validation.message.password.required">You must enter your password to log in.</validation-message>
            </validation>
        </div>
        <div class="button-row left-align">
            <button test-id="login.button.signin"
                class="default white-spinner submit"
                type="submit"
                [attr.state]="loginButtonState"
                i18n="@@landingpage.button.signin"
                *ngIf="showInternalLogin && !disableInternalLogin"
            >Log in</button>
            <span
                class="login-button-seperator"
                *ngIf="showInternalLogin && showExternalLogin && !disableInternalLogin"
                i18n="@@landingpage.login.button.seperator.text"
            >or</span>
            <a class="button default submit external-login"
                [href]="externalLoginLink + getUserName()"
                *ngIf="showExternalLogin && !disableInternalLogin"
                test-id="login.link.externallogin"
            >
                {{externalLoginText}}
            </a>
            <a class="button default submit external-login"
                [href]="externalLoginLink + getUserName()"
                *ngIf="disableInternalLogin"
                test-id="login.link.specificExternalLogin"
            >
                {{loginWithSpecificExternalLoginText}}
            </a>
            <div class="login-options">
                <a class="no-access"
                    *ngIf="showInternalLogin && !disableInternalLogin && !disablePassword"
                    [routerLink]="['/ResetPassword']"
                    i18n="@@landingpage.resetpassword.link.text"
                    test-id="login.link.passwordreset"
                >Reset my Password</a>
            </div>
        </div>
    </form>
</div>